import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default () => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">Partner Update</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y, Z where, <br />
          X = Number of partners from 1st day of the month/quarter to selected
          date, <br />
          Y = Number of active partners from 1st day of the month/quarter to
          selected date, <br />Z = Number of total partners
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
